$(document).ready(function(){
//home best seller
  $('.slider-collection').slick({
  infinite: true,
   dots: true,
  slidesToShow: 4,
  slidesToScroll: 1,
    appendArrows: '.slider-collection-arrows',
    prevArrow:"<svg width='20' height='36' viewBox='0 0 20 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M18.4174 35.2236C18.7128 35.2236 19.0152 35.1068 19.2419 34.8801C19.6954 34.4266 19.6954 33.6845 19.2419 33.2311L3.72043 17.7095L19.0152 2.41477C19.4687 1.96128 19.4687 1.21922 19.0152 0.765736C18.5617 0.312252 17.8197 0.312252 17.3662 0.765736L1.24002 16.885C0.786531 17.3385 0.786531 18.0806 1.24002 18.5341L17.586 34.8801C17.8197 35.1137 18.1151 35.2236 18.4174 35.2236Z' fill='black'/></svg>",
    nextArrow:"<svg width='19' height='36' viewBox='0 0 19 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.48251 35.2236C1.18705 35.2236 0.884697 35.1068 0.657955 34.8801C0.20447 34.4266 0.20447 33.6845 0.657955 33.2311L16.1795 17.7095L0.884695 2.41477C0.431211 1.96128 0.431211 1.21922 0.884695 0.765736C1.33818 0.312252 2.08024 0.312252 2.53373 0.765736L18.6599 16.885C19.1134 17.3385 19.1134 18.0806 18.6599 18.5341L2.31386 34.8801C2.08025 35.1137 1.78483 35.2236 1.48251 35.2236Z' fill='black'/></svg>",
       responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

  //homepage testimonial
  $('.testimonal-slider').slick({
  infinite: true,
   dots: true,
  slidesToShow: 2,
  slidesToScroll: 2,
    appendArrows: '.testi_run_arrow',
    prevArrow:"<svg width='19' height='35' viewBox='0 0 19 35' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M17.8354 34.8365C18.1308 34.8365 18.4332 34.7197 18.6599 34.493C19.1134 34.0395 19.1134 33.2975 18.6599 32.844L3.1384 17.3225L18.4332 2.02768C18.8867 1.5742 18.8867 0.832134 18.4332 0.378651C17.9797 -0.0748329 17.2376 -0.0748329 16.7841 0.378651L0.657984 16.4979C0.2045 16.9514 0.2045 17.6935 0.657984 18.147L17.004 34.493C17.2376 34.7266 17.533 34.8365 17.8354 34.8365Z' fill='white'/></svg>",
    nextArrow:"<svg width='19' height='35' viewBox='0 0 19 35' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.48251 34.8365C1.18705 34.8365 0.884697 34.7197 0.657955 34.493C0.20447 34.0395 0.20447 33.2975 0.657955 32.844L16.1795 17.3225L0.884695 2.02768C0.431211 1.5742 0.431211 0.832134 0.884695 0.378651C1.33818 -0.0748329 2.08024 -0.0748329 2.53373 0.378651L18.6599 16.4979C19.1134 16.9514 19.1134 17.6935 18.6599 18.147L2.31386 34.493C2.08025 34.7266 1.78483 34.8365 1.48251 34.8365Z' fill='white'/></svg>",
       responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

  //collection list
  $('.collection_list-slider').slick({
  infinite: true,
   dots: false,
  slidesToShow: 4,
  slidesToScroll: 1,
    //appendArrows: '.collection_list_arrow',
  
    prevArrow:"<div class='collection_left'><svg width='20' height='36' viewBox='0 0 20 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M18.4174 35.2236C18.7128 35.2236 19.0152 35.1068 19.2419 34.8801C19.6954 34.4266 19.6954 33.6845 19.2419 33.2311L3.72043 17.7095L19.0152 2.41477C19.4687 1.96128 19.4687 1.21922 19.0152 0.765736C18.5617 0.312252 17.8197 0.312252 17.3662 0.765736L1.24002 16.885C0.786531 17.3385 0.786531 18.0806 1.24002 18.5341L17.586 34.8801C17.8197 35.1137 18.1151 35.2236 18.4174 35.2236Z' fill='black'/></svg></div>",
    nextArrow:"<div class='collection_right'><svg width='19' height='36' viewBox='0 0 19 36' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.48251 35.2236C1.18705 35.2236 0.884697 35.1068 0.657955 34.8801C0.20447 34.4266 0.20447 33.6845 0.657955 33.2311L16.1795 17.7095L0.884695 2.41477C0.431211 1.96128 0.431211 1.21922 0.884695 0.765736C1.33818 0.312252 2.08024 0.312252 2.53373 0.765736L18.6599 16.885C19.1134 17.3385 19.1134 18.0806 18.6599 18.5341L2.31386 34.8801C2.08025 35.1137 1.78483 35.2236 1.48251 35.2236Z' fill='black'/></svg></div>",
       responsive: [
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

      //product page slider
 $('.slider-main-image').slick({
     prevArrow: "<div class='product pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
   nextArrow: "<div class='product next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",  
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
  // fade: true,
   infinite: true,
   asNavFor: '.slider_left_image'
 });
  
 $(".slider_left_image").slick({
  prevArrow: "<div class='pre-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M14.4374 16L21.0374 22.6L19.1521 24.4854L10.6667 16L19.1521 7.51468L21.0374 9.40135L14.4374 16.0014V16Z' fill='black'/></svg></div>",
   nextArrow:  "<div class='next-btn'><svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32' fill='none'><path d='M17.5626 16L10.9626 22.6L12.8479 24.4854L21.3333 16L12.8479 7.51468L10.9626 9.40135L17.5626 16.0014V16Z' fill='black'/></svg></div>",                  
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: false,
      arrows: false,
      vertical: true,
      asNavFor: '.slider-main-image',
      focusOnSelect: true,
         responsive: [
    {
      breakpoint: 767,
      settings: {
      vertical: false,
       slidesToShow: 3,
      },
    },
  ],
   
  });


  

  //collection page grid listing

  $('.gridss').click(function(){
      $(this).parents('.product-grid-container').find('.custom-coll').addClass('grid-view');
      $(this).parents('.product-grid-container').find('.custom-coll').removeClass('listing-view');
      $(this).addClass('active');
      $(this).parents('.product-grid-container').find('.lsitingg').removeClass('active');
});
$('.lsitingg').click(function(){
    $(this).parents('.product-grid-container').find('.custom-coll').addClass('listing-view');
    $(this).parents('.product-grid-container').find('.custom-coll').removeClass('grid-view');
    $(this).addClass('active');
    $(this).parents('.product-grid-container').find('.gridss').removeClass('active');
});
});

